const LOCAL_DEV_DOMAIN_SUFFIX = '.localhost';

export function getHostname(): string {
    return typeof location === 'undefined' ? '' : location.hostname;
}

// The dev server is reachable as `localhost` and, behind a local reverse proxy that gives every git
// worktree its own hostname (portless), as `<branch>.antcp.localhost`. Both are the same local build
// talking to a remote backend through the vite proxy, so they must be treated alike.
export function getIsLocalDevelopmentHost(): boolean {
    const hostname = getHostname();

    return hostname === 'localhost' || hostname.endsWith(LOCAL_DEV_DOMAIN_SUFFIX);
}

/**
 * Derive a sibling service host from the app host, the way the real domains are laid out
 * (`go.rocketdata.io` -> `survey.rocketdata.io`). A local dev host has no such sibling, so the app
 * host is returned untouched — substituting there would also mangle a branch name that happens to
 * contain the searched text, e.g. `dev-1-google.antcp.localhost`.
 */
export function getSiblingServiceOrigin(origin: string, replaced: RegExp | string, replacement: string): string {
    return getIsLocalDevelopmentHost() ? origin : origin.replace(replaced, replacement);
}
